export const FAQ_CATEGORIES = ['Account', 'Transfers', 'Security', 'Loans', 'Fixed Deposit'] as const
export type FAQCategory = typeof FAQ_CATEGORIES[number]

export const FAQ_CATEGORY_STYLES: Record<string, { bg: string; color: string }> = {
    Account:         { bg: '#EFF8FF', color: '#175CD3' },
    Transfers:       { bg: '#ECFDF3', color: '#027A48' },
    Security:        { bg: '#FEF3F2', color: '#B42318' },
    Loans:           { bg: '#F4F3FF', color: '#5925DC' },
    'Fixed Deposit': { bg: '#FFFAEB', color: '#B54708' },
}

export const getCategoryStyle = (category: string) =>
    FAQ_CATEGORY_STYLES[category] ?? { bg: '#F2F4F7', color: '#667085' }